/**
 * Filtered lens - Pattern-based selection
 * Projects lines based on pattern matching with position-based threshold
 */

import type { CascadeLens, Block } from '../types';

export const filteredLens: CascadeLens = {
  id: 'filtered',
  name: 'Filtered',
  project: (position: number, cascade: Block): string[] => {
    const { lines } = cascade;
    if (lines.length === 0) return [];

    // Use position to control filtering intensity
    // At position 0: show only lines containing common words
    // At position 1: show all lines
    const threshold = position;

    // Simple pattern-based filtering
    // This is a placeholder implementation - can be enhanced based on specific requirements
    const patterns = [
      /the|and|or|to|of|in|for|with|by/i, // Common words (shown at low threshold)
      /\d+/,                               // Numbers
      /[A-Z][a-z]+/,                      // Capitalized words
      /.*/,                               // All lines (shown at high threshold)
    ];

    const patternIndex = Math.floor(threshold * (patterns.length - 1));
    const activePattern = patterns[patternIndex];

    return lines.filter(line => activePattern.test(line));
  },
  sliderConfig: {
    steps: 10,
    labels: ['Filtered', 'All'],
  },
};